import { nanoid } from "nanoid";
import constants from "../constants";
import { useState, useContext } from "react";
import useAxiosPrivate from "./useAxiosPrivate";
import AlertContext from "../context/AlertContext";
import useCommonFunctionHooks from "./useCommonFunctionHooks";

const useAddOrUpdateLp = () => {
  const Alert = useContext(AlertContext);

  const axios = useAxiosPrivate();

  const { getHeaderDetailsForAxios, getCatchBlockDetails } =
    useCommonFunctionHooks();

  const [successRes, setSuccessRes] = useState({
    msg: "",
    title: "",
    isSuccess: false,
    isProctored: false,
  });

  const handleAddOrUpdateLp = (newLpDetails, modules, setModules, mockuse) => {
    return new Promise((resolve, reject) => {
      let found = 0,
        orderno = 1,
        typefound = 0,
        moduleorderno = 1,
        newDetails = Alert.isOldLpDetail
          ? JSON.parse(JSON.stringify(Alert.lpData2))
          : JSON.parse(JSON.stringify(newLpDetails));

      if (mockuse) {
        newDetails.mockuse = mockuse;
        newDetails.tags = Alert.selectedTag;
      }

      newDetails.modules = JSON.parse(JSON.stringify(modules ?? []));

/* module order logic */
      if (!newDetails.selectedModule.value) {
        moduleorderno = Math.max(...newDetails.parentModules.map(m => m.maxmodorderno || 1)) + 1;
      } else {
        let found = newDetails.parentModules.find(m => m.id === newDetails.selectedModule.value);

        if (found) {
          let prevModule = newDetails.parentModules.find(m => m.moduleorderno === (found.moduleorderno - 1));
          moduleorderno = prevModule ? (prevModule?.maxmodorderno || 1) + 1 : 1;
        } else {
          moduleorderno = 1;
        }
      }

      if (newDetails.modules.length > 0) {
        for (let i = 0; i < newDetails.modules.length; i++) {
          if (newDetails.modules[i].moduleName !== "") {
            if (newDetails.modules[i].moduleData.length > 0) {
              for (
                let j = 0;
                j < newDetails.modules[i].moduleData.length;
                j++
              ) {
                newDetails.modules[i].moduleData[j].orderno = orderno;
                orderno++;
              }

              newDetails.modules[i].moduleorderno = moduleorderno;
              moduleorderno++;
            } else {
              newDetails.modules[i].moduleorderno = moduleorderno;
              moduleorderno++;
            }
          } else {
            Alert.setShowNotify({
              show: true,
              title: "Warning",
              msg: "Please give chapter name",
            });

            found = 1;
            break;
          }
        }
      } else {
        found = 1;
        
        Alert.setShowNotify({
          show: true,
          title: "Warning",
          msg: "Please add chapter",
        });
      }

      if (found === 0) {
        Alert.setIsLoaded(true);

        if (!newDetails?.parentModules[newDetails.cMId]?.hasOwnProperty("id")) {
          axios
            .post(
              process.env.REACT_APP_NODE_API + "node/admin/learningpath/create",
              JSON.stringify(newDetails),
              getHeaderDetailsForAxios()
            )
            .then((creatLpRes) => {
              let data = creatLpRes.data;

              if (data.resultCode === constants.RESULT_STATUS.SUCCESS) {
                if (data.msg.includes("created")) {
                  resolve({
                    data,
                  });
                } else {
                  reject(
                    Alert.setShowNotify({
                      show: true,
                      msg: data.msg,
                      title: "Warning!",
                    })
                  );
                }
              } else if (
                data.resultCode === constants.RESULT_STATUS.TECHNICAL_ERROR &&
                data.msg.sqlMessage.includes("Duplicate entry")
              ) {
                Alert.setIsAddLpModule(false);

                reject(
                  Alert.setShowNotify({
                    show: true,
                    title: "Warning!",
                    msg: "The path name is already taken.",
                  })
                );
              } else {
                reject(
                  Alert.setShowNotify({
                    show: true,
                    title: "Error!",
                    msg: "Something went wrong. Please try again later.",
                  })
                );
              }
            })
            .catch((createTestErr) => {
              getCatchBlockDetails(createTestErr);
            })
            .finally(() => Alert.setIsLoaded(false));
        } else {
          if (newDetails.status === "" || !newDetails.status) {
            for (let i = 0; i < newDetails.modules.length; i++) {
              if (
                newDetails.modules[i].status === "new" ||
                newDetails.modules[i].moved === "yes"
              ) {
                typefound = 1;
                break;
              }

              for (
                let j = 0;
                j < newDetails.modules[i].moduleData.length;
                j++
              ) {
                if (
                  newDetails.modules[i].moduleData[j].status === "new" ||
                  newDetails.modules[i].moduleData[j].moved === "yes"
                ) {
                  typefound = 1;
                  break;
                }
              }

              if (typefound === 1) break;
            }
          } else if (newDetails.status === "update") typefound = 1;

          newDetails.batchType = Alert.batchDetails.batchtype;

          if (typefound === 1) {
            axios
              .post(
                process.env.REACT_APP_NODE_API +
                  "node/admin/learningpath/update",
                JSON.stringify(newDetails),
                getHeaderDetailsForAxios()
              )
              .then((updateLpRes) => {
                if (
                  updateLpRes.data.resultCode ===
                  constants.RESULT_STATUS.SUCCESS
                ) {
                  newDetails.resultCode = updateLpRes.data.resultCode;

                  resolve({
                    data: newDetails,
                  });
                } else {
                  Alert.setShowNotify({
                    show: true,
                    title: "Warning!",
                    msg: "Something went wrong. Please try again later.",
                  });
                }
              })
              .catch((updateLpErr) => {
                if (updateLpErr.message.includes("403")) {
                  Alert.setShowNotify({
                    show: true,
                    isUnAuth: true,
                    title: "Error!",
                    msg: "You have been logged-out due to inactivity. Login again...",
                  });
                }
              })
              .finally(() => Alert.setIsLoaded(false));
          } else {
            Alert.setIsLoaded(false);

            Alert.setShowNotify({
              show: true,
              title: "Success",
              msg: "There is no data to update",
            });
          }
        }
      }
    });
  };

  return { handleAddOrUpdateLp, successRes, setSuccessRes };
};

export default useAddOrUpdateLp;
